export var TYPE_RADIO = 'radio';
export var TYPE_CHECKBOX = 'checkbox';